import {Coefficient} from "./coefficient";
import {MultiServiceBoost} from "./multi-service-boost";

export class QuoteServicePct {
    readonly serviceCode: string;
    readonly coefficient: Coefficient;
    readonly multiServiceBoost: MultiServiceBoost;
    readonly quoteServiceAppliedPriceColor: string;
    readonly quoteServiceMonthlyAmount: number;
    readonly nonNegociableArticlesMonthlyAmount: number;
    readonly negociableArticlesMonthlyAmount: number;
    readonly quoteServiceContractDuration: number;
    readonly cmcUniqueReference: boolean;
    readonly nonNegociableArticleColor: string;
    readonly uniqueReferenceCoefficient: number;
    readonly defaultContractDuration: number;

    constructor(serviceCode:string, multiServiceBoost: MultiServiceBoost, coefficient: Coefficient, quoteServiceAppliedPriceColor: string, quoteServiceMonthlyAmount: number, nonNegociableArticlesMonthlyAmount: number, negociableArticlesMonthlyAmount: number, quoteServiceContractDuration: number, cmcUniqueReference: boolean, nonNegociableArticleColor: string, uniqueReferenceCoefficient: number, defaultContractDuration?: number) {
        this.serviceCode= serviceCode;
        this.coefficient = coefficient;
        this.multiServiceBoost = multiServiceBoost;
        this.quoteServiceAppliedPriceColor = quoteServiceAppliedPriceColor;
        this.quoteServiceMonthlyAmount = quoteServiceMonthlyAmount;
        this.nonNegociableArticlesMonthlyAmount = nonNegociableArticlesMonthlyAmount;
        this.negociableArticlesMonthlyAmount = negociableArticlesMonthlyAmount;
        this.quoteServiceContractDuration = quoteServiceContractDuration;
        this.cmcUniqueReference = cmcUniqueReference;
        this.nonNegociableArticleColor = nonNegociableArticleColor;
        this.uniqueReferenceCoefficient = uniqueReferenceCoefficient;
        this.defaultContractDuration = defaultContractDuration;
    }
}